import { getJson } from "../../../../lib/api-client";

const BASE = "/api/v1/admin/web3/combined";

function cleanParams(obj) {
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v === undefined || v === null || v === "") continue;
    out[k] = v;
  }
  return out;
}

export function getCombinedStats({ from, to } = {}) {
  return getJson(`${BASE}/stats`, cleanParams({ from, to }));
}

export function getCombinedUsers({ from, to, page = 1, limit = 20 } = {}) {
  return getJson(`${BASE}/users`, cleanParams({ from, to, page, limit }));
}
